import React, { useContext, useRef } from 'react'
import { AppContext } from '../context/AppContext'
import styled from 'styled-components'
import useClickOutside from '../hooks/useClickOutside'
import {StripeForm} from './StripeForm'

export default function StripeModal({title}) {
  const {appDispatch} = useContext(AppContext)
  const modalRef = useRef(null)
  const closeModal = () => {
    appDispatch({type: 'closeStripeModal'})
  }
  useClickOutside(modalRef, closeModal)
  return (
    <>
      <ModalBackground />
      <ModalWrapper ref={modalRef}>
        <Title>{title}</Title>
        <StripeForm />
      </ModalWrapper>
    </>
  )
}

const ModalWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1002;
  background: ${({theme}) => theme.background};
  color: ${({theme}) => theme.text};
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
`

const ModalBackground = styled.div`
  position: fixed;
  inset: 0;
  background: ${({theme}) => theme.text};
  opacity: 0.3;
  z-index: 1001;
  cursor: pointer;
`

const Title = styled.h3`
  text-align: center;
`